import React from 'react';
import createPlotlyComponent from 'react-plotly.js/factory';
import Plotly from 'plotly.js-basic-dist-min';
interface IProps {
  chartProps: any;
}
const Plot = createPlotlyComponent(Plotly);

export const DataSizeChart = (props: IProps) => {
  const { data, layout, config } = props.chartProps;
  return <Plot {...{data, layout, config}} />;
};
